"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterCardPayType = filterCardPayType;
exports.filterCardType = filterCardType;
exports.filterIsPromoter = filterIsPromoter;
exports.filterMemberBenefits = filterMemberBenefits;
exports.filterMemberType = filterMemberType;
exports.filterTheme = filterTheme;
exports.registerTypeFilter = registerTypeFilter;
exports.tagFilter = tagFilter;
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

//会员过滤器

/**
 * 用户注册类型
 */
function registerTypeFilter(status) {
  var statusMap = {
    wechat: '公众号',
    routine: '小程序',
    h5: 'H5',
    iosWx: '微信ios',
    androidWx: '微信安卓',
    ios: 'ios'
  };
  return statusMap[status];
}

/**
 * 用户类型
 */
function filterIsPromoter(status) {
  var statusMap = {
    true: '推广员',
    false: '普通用户'
  };
  return statusMap[status];
}

/**
 * 标签
 */
function tagFilter(status) {
  if (!status) {
    return '-';
  }
  if (!localStorage.getItem('tagAllList')) return;
  var arr = JSON.parse(localStorage.getItem('tagAllList'));
  var obj = {};
  for (var i in arr) {
    obj[arr[i].id] = arr[i];
  }
  var strArr = status.split(',');
  var newArr = [];
  var _iterator = _createForOfIteratorHelper(strArr),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      if (obj[item]) {
        newArr.push(obj[item].name);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return newArr.join(',');
}

/**
 * 会员权益
 */
function filterMemberBenefits(status) {
  var statusMap = {
    experienceDoubling: '经验值翻倍',
    integralDoubling: '积分翻倍',
    memberExclusivePrice: '会员专享价',
    exclusiveCustomer: '专属客服'
  };
  return statusMap[status];
}

/**
 * 会员权益
 */
function filterMemberType(status) {
  var statusMap = {
    0: '试用',
    1: '期限',
    2: '永久'
  };
  return statusMap[status];
}

/**
 * 会员卡支付方式
 */
function filterCardPayType(status) {
  var statusMap = {
    weixin: '微信',
    alipay: '支付宝',
    give: '平台赠送',
    yue: '余额'
  };
  return statusMap[status];
}

/**
 * 会员卡类型
 */
function filterCardType(status) {
  var statusMap = {
    0: '试用',
    1: '期限',
    2: '永久'
  };
  return statusMap[status];
}
/**
 * 移动端主题色
 */
function filterTheme(status) {
  var statusMap = {
    0: '#e93323',
    1: '#fe5c2d',
    2: '#42ca4d',
    3: '#1ca5e9',
    4: '#ff448f'
  };
  return statusMap[status];
}